var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.987.73c.097-.454-.348-.837-.782-.671L.377 7.246C.15 7.333.001 7.55 0 7.792c0 .243.149.46.375.548l5.29 2.043v6.434c0 .271.185.507.45.57.262.062.535-.062.658-.306l2.188-4.341 5.338 3.961c.325.241.792.088.91-.3C20.193.06 19.978.772 19.987.73zm-4.648 2.059L6.167 9.32 2.221 7.797l13.118-5.008zm-8.503 7.494l7.995-5.694c-6.88 7.258-6.52 6.876-6.55 6.916-.045.06.077-.174-1.445 2.847v-4.069zm7.494 4.982l-4.699-3.487 8.497-8.963-3.798 12.45z",
    transform: "translate(-932 -862) translate(50 811) translate(867 40) translate(15 11)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.6d158d9ddb02af2f2facddae5a714d88.svg";
export { ForwardRef as ReactComponent };